// Loaded from CDN and included in externals in webpack.config.js
import MathJax from "mathjax";

// Required JS from node_modules
import React from "react";
import { createRoot } from "react-dom/client";

// Required JS from local files
import {
   addInitialFunction,
   Context,
   dfmAlert,
   isTeacher,
} from "./dfm5";
import LessonResourcesHome from "~/components/pages/downloadables/LessonResourcesHome";
import { getCourseGroupsForDropdown, getUnit } from "~/utils/courses";
import { getDownloadablesForCourseUnit } from "~/utils/downloadables";
import { posthogPageviewEvent } from "~/utils/posthog/general";
import { posthogEventResourceFileDownloaded, posthogEventResourceGroupSelected } from "~/utils/posthog/resources";

// CSS
import "./downloadables.css";

const collections = [
   { label: "Royal Meteorological Society", href: "/rmets.php" },
   {
      label: "Virtual Calculators",
      href: "/downloadables.php?noid=77",
      onClick: () => {
         posthogEventResourceGroupSelected({
            triggerId: "downloadables-virtual-calculators-link",
            groupType: "node",
            node: { noid: 77, name: "Virtual Calculators" },
         });
      },
   },
]

const enrichment = [
   { label: "UKMT Advice for Schools", href: "/page.php?id=14" },
   { label: "UKMT Database", href: "/browse.php?mode=ukmt" },
   { label: "Oxbridge", href: "/page.php?id=7" },
   {
      label: "Year 12 Zeta Club",
      href: "/downloadables.php?noid=917",
      onClick: () => {
         posthogEventResourceGroupSelected({
            triggerId: "downloadables-zeta-club-link",
            groupType: "node",
            node: { noid: 917, name: "Senior" },
         });
      },
   },
]

function renderDownloadablesList(downloadables, displayResourceTitle = true) {
   $.each(downloadables, function(k, d) {
      $("#downloadables-list").append("<div id='downloadable-"+d.rid+"'></div>");
      $("#downloadable-"+d.rid).append("<div class='downloadables-list-info'>"
        +"<img src='images/downloadables_icon.svg'>"
        +(displayResourceTitle ? "<h1>"+d.title+"</h1>" : "")
        +"<p>"+d.description+"</p>"
        +"<p><a id='report-mistake-" + d.rid + "'>Report a Mistake</a></p>"
        +"</div>");
      const reportErrorEmailSubject = encodeURIComponent(`Error Report: ${d.title} (ID: ${d.rid})`);
      $(`#report-mistake-${d.rid}`).prop("href", `mailto:resources@drfrost.org?subject=${reportErrorEmailSubject}`);
      $("#downloadable-"+d.rid).append("<ul></ul>");
      $.each(d.files, function(k2,f) {
         $("#downloadable-"+d.rid+" ul").append("<li style='cursor:pointer;' id='downloadable-file-"+f.fid+"'>"
            +"   <span style='font-weight:700;' class='download'>Download</span>"
            +"   <span class='"+(f.access==1 ? 'locked' : 'notlocked')+"'></span>"
            +"   <h1>"+f.filename.split("/")[f.filename.split("/").length-1]+"</h1>"
            +"   <h2>"+f.type+"</h2>"
            +"</li>");
         const handlePostHogEvent = () => {
            if (f && d) {
               posthogEventResourceFileDownloaded({
                  triggerId: "downloadables-resource-file",
                  file: f,
                  resource: d,
                  results: downloadables.length,
                  position: k + 1,
               });
            }
         }
         $("#downloadable-file-"+f.fid).on("click", () => downloadFile({
            file: f,
            onSuccess: handlePostHogEvent
         }));
      });
   });
}

function loadDownloadablesByRidOrNoid(options) {
   $("#downloadables-topicheader .arrow-back").on("click", () => {
      window.location = '/downloadables.php';
   })
   console.log("[LoadDownloadables] options = "+JSON.stringify(options));
   const { noid, rid } = options ?? {};
   var url = "/api/downloadables/bytopic?" + (noid ? "noid=" + noid : "rid=" + rid);
   $.ajax({
      url: url,
      context: document.body,
      dataType: "json",
      success: function(data){

         const downloadables = data.downloadables ?? [];

         $("#downloadables-list").empty();

         if (noid) {
            document.title = data.node?.name ? `Lesson Resources - ${data.node.name}` : "Lesson Resources";
            $("#downloadables-topicheader h1").html(data.node ? data.node.name : "-");
            $("#downloadables-topicheader h2").html((data.node ? data.node.pathcache[0].name : "-")+" &rarr; "+(data.node ? data.node.pathcache[1].name : "-")+" &rarr;");
            renderDownloadablesList(downloadables, true);
         } else if (rid) {
            const resource = downloadables[0] ?? {};
            const title = resource.title ?? "-";
            document.title = title ? `Lesson Resources - ${title}` : "Lesson Resources";
            $("#downloadables-topicheader h1").html(title);
            $("#downloadables-topicheader h2").html("Lesson Resource");
            renderDownloadablesList(downloadables, false);
         }

         $("#downloadables-list").show();
         $("#downloadables-topicheader").show();

         MathJax.typeset();
      },
      error: function(jqXHR, textStatus, errorThrown){
         dfmAlert("There was an error retrieving this list of downloadables:<br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });
}

function renderDownloadablesByUnit(downloadables, unit) {
   // Prepare the back arrow navigation, using sessionStorage to provide context for the courses dropdown.
   sessionStorage.setItem("downloadablesCourseId", unit?._module?.coid);
   sessionStorage.setItem("downloadablesModuleId", unit?._module?.cmid);
   $("#downloadables-topicheader .arrow-back").on("click", () => {
      window.location = '/downloadables.php';
   })

   // Empty the downloadables list.
   $("#downloadables-list").empty();

   // Render the downloadables list.
   renderDownloadablesList(downloadables ?? []);

   // Render a message to the list if there are no downloadables.
   if (!downloadables || downloadables.length === 0) {
      $("#downloadables-list").append("<h3 style='color: gray; font-weight: bold; text-align: center;'>Sorry. This unit does not have any downloadables yet.</h3>");
   }

   // Ensure the list is displayed.
   $("#downloadables-list").show();

   // Prepare the title of the page.
   const publisherName = unit?.pathcache?.[0]?.name ?? "";
   const moduleName = unit?.pathcache?.[1]?.name ?? "";
   const unitName = unit?.name ?? ""
   $("#downloadables-topicheader h1").html(unitName);
   $("#downloadables-topicheader h2").html(`${publisherName} ${publisherName ? "&rarr;" : ""} ${moduleName} ${moduleName ? "&rarr;" : ""}`);
   $("#downloadables-topicheader").show();

   // Typeset any LaTeX.
   MathJax.typeset();
}

function downloadFile({ file, onSuccess }) {
   if(file.access==1 && !isTeacher()) {
      dfmAlert("This resource is available to teachers only.");
   } else {
      $.ajax({
         url: "/api/downloadables/download/"+file.fid,
         success: (filepath) => {
            if (typeof onSuccess === "function") {
               onSuccess();
            }
            window.location = filepath;
         },
         error: (e) => console.log(e)
      })
   }
}

async function getLatestResources() {
   const response = await fetch("/api/resources/latest");
   if (response.ok) {
      return response.json();
   } else {
      throw new Error;
   }
}

async function renderPage (preloadState) {
   // Send a page view event.
   posthogPageviewEvent();

   // Also send a page view event if we've navigated here via the bfcache
   window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
         posthogPageviewEvent();
      }
   });

   if (preloadState.cuid) {
      const [unit, downloadables] = await Promise.all([
         getUnit(preloadState.cuid, false), 
         getDownloadablesForCourseUnit(preloadState.cuid)
      ]);
      renderDownloadablesByUnit(downloadables, unit);
   } else if (preloadState.rid || preloadState.noid) {
      loadDownloadablesByRidOrNoid(preloadState);
   } else {
      document.title = "Lesson Resources - Home";
      const [latestResources = [], courseGroups = []] = await Promise.all([
         getLatestResources(),
         getCourseGroupsForDropdown({ user: Context?.user })
      ]);
      const reactRoot = createRoot(document.getElementById("downloadables-home"));
      const initialCourseId = sessionStorage.getItem("downloadablesCourseId") ? parseInt(sessionStorage.getItem("downloadablesCourseId")) : null;
      const initialModuleId = sessionStorage.getItem("downloadablesModuleId") ? parseInt(sessionStorage.getItem("downloadablesModuleId")) : null;
      sessionStorage.removeItem("downloadablesCourseId");
      sessionStorage.removeItem("downloadablesModuleId");
      reactRoot.render(
         <LessonResourcesHome
            collections={collections}
            courseGroups={courseGroups}
            enrichment={enrichment}
            initialCourseId={initialCourseId}
            initialModuleId={initialModuleId}
            latestResources={latestResources}
            manageCoursesHref="/manage-courses.php"
            user={Context?.user}
         />
      );
   }
}

$(() => {
   addInitialFunction(() => renderPage(preloadState));
});
